<!-- <router-outlet  ></router-outlet> -->
<app-container
  *ngIf="!displayErrorPage"
  [albo]="albo"
></app-container>
<app-page-not-found *ngIf="displayErrorPage"></app-page-not-found>
